import React from "react";
import classNames from "classnames";
import Welcome from "ComponentsUI/Welcome";
import AlertWrapper from "ComponentsUI/AlertWrapper";
import { TextField } from "ComponentsUI/TextField";
import Button from "ComponentsUI/Button";
import { CircleButton } from "ComponentsUI/SideWidgets";
import { FromFade } from "ComponentsUI/Animations";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			height: "60px",
			position: "relative",
		},
		wrapper: {
			position: "relative",
			width: "60px",
			height: "60px",
			backgroundColor: theme.palette.colors.white,
			borderRadius: "50%",
		},
		window: {
			width: 0,
			height: 0,
			padding: 0,
			position: "relative",
			opacity: 0,
			display: "flex",
			flexDirection: "column",
		},
		windowClose: {
			right: "30px",
			top: "-30px",
			width: "60px",
			height: "60px",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			borderRadius: "50%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			cursor: "pointer",
			position: "absolute",
			backgroundColor: theme.palette.colors.white,
			zIndex: 10,
			"& span": {
				fontSize: "16px",
				color: theme.palette.colors.lightGrayishViolet,
			},
		},
		windowHeader: {
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			lineHeight: 1,
			color: theme.palette.colors.darkSlateBlue,
			maxWidth: "240px",
			marginBottom: "18px",
		},
		windowText: {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: "1.25",
			color: theme.palette.colors.oneMoreGrey,
			maxWidth: "240px",
			marginBottom: "30px",
		},
		windowPanel: {
			display: "flex",
			flexWrap: "wrap",
			width: "100%",
		},
		inputWrapper: {
			marginBottom: "20px",
			width: "100%",
		},
		windowWrapper: {
			display: "flex",
			alignItems: "flex-start",
			flexDirection: "column",
		},
		windowWrapperSuccess: {
			padding: "75px 0",
		},
		rootIsOpen: {
			zIndex: 2,
			"& $wrapper": {
				height: "auto",
				width: "380px",
				bottom: "20px",
				right: "20px",
				position: "fixed",
				borderRadius: "10px",
				border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			},
			"& $window": {
				width: "100%",
				height: "auto",
				position: "relative",
				padding: "30px",
				opacity: 1,
			},
			"& $overlay": {
				position: "fixed",
				left: 0,
				right: 0,
				top: 0,
				bottom: 0,
				backgroundColor: `rgba(43, 29, 92, 0.3)`,
				zIndex: "-1",
			},
		},
		overlay: {},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			windowHeader: {
				fontSize: "16px",
				maxWidth: "250px",
				marginBottom: "18px",
			},
			windowText: {
				fontSize: "14px",
				lineHeight: "1.29",
				maxWidth: "250px",
				marginBottom: "16px",
			},
			wrapper: {},
			rootIsOpen: {
				"& $wrapper": {
					bottom: 0,
					right: 0,
					borderRadius: "10px 0 0",
				},
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				height: "50px",
			},
			wrapper: {
				width: "50px",
				height: "50px",
			},
			window: {
				transition: "none",
			},
			windowClose: {
				right: "20px",
				top: "-25",
				width: "50px",
				height: "50px",
				border: "none",
				boxShadow: "0 2px 4px 0 rgba(44, 29, 93, 0.3)",
				"& span": {
					fontSize: "16px",
				},
			},
			windowHeader: {
				fontSize: "18px",
				maxWidth: "80%",
				marginBottom: "14px",
			},
			windowText: {
				fontSize: "14px",
				lineHeight: "1.29",
				maxWidth: "90%",
				marginBottom: "22px",
			},
			windowPanel: {
				alignItems: "flex-end",
				justifyContent: "space-between",
			},
			inputWrapper: {
				width: "100%",
			},
			rootIsOpen: {
				"& $wrapper": {
					width: "100%",
					bottom: "0",
					right: "0",
					borderRadius: "0",
					padding: "0 20px",
					transition: "none",
					border: "none",
				},
				"& $window": {
					padding: "30px 8.33%",
				},
			},
		},
		[`@media (max-width: ${theme.media.xs})`]: {
			windowPanel: {
				alignItems: "flex-end",
				justifyContent: "space-between",
			},
			inputWrapper: {
				width: "100%",
				marginBottom: "20px",
			},
		},
	};
};

class CallbackFixed extends React.Component {
	clickOnIcon() {
		if (this.props.isOpen) {
			this.props.openAddReview();
		} else {
			this.props.openWindow();
		}
	}

	render() {
		let callbackSended = this.props.callbackSended;
		const classes = this.props.classes;
		const text = this.props.text;
		return (
			<div
				className={classNames(classes.root, {
					[classes.rootIsOpen]: this.props.isOpen,
				})}
			>
				<div className={classes.wrapper}>
					<CircleButton
						datatest="main_callback_button"
						onClick={() => {
							this.clickOnIcon();
						}}
						yellowTheme={true}
						isHide={this.props.isOpen}
						blinking={!this.props.typeB && !this.props.isOpen}
						typeB={this.props.typeB}
					>
						<span className="icon24 icon-call-in" />
					</CircleButton>
					<div className={classes.window}>
						<div
							className={classes.windowClose}
							onClick={() => {
								this.props.closeWindow();
							}}
						>
							<span className="icon24 icon-close" />
						</div>
						{this.props.isOpen && (
							<div>
								{!callbackSended && (
									<form className={classes.windowWrapper}>
										<div className={classes.windowHeader}>{text.CALLBACK_GREEN_TITLE}</div>
										<div className={classes.windowText}>{text.CALLBACK_GREEN_TEXT}</div>
										<div className={classes.windowPanel}>
											<div className={classes.inputWrapper}>
												<AlertWrapper
													error={this.props.error}
													small={true}
													datatest="callback_texterror"
												>
													<TextField
														autocomplete="tel"
														name="tel"
														onBlur={this.props.onBlurPhone}
														placeholder="+7"
														id="fix_callback_phone"
														type={"phone"}
														formatting={"phone"}
														value={this.props.phone}
														onEnter={(e) => this.props.sendOrder(e, this.carousel)}
														onChange={this.props.changePhoneConnection}
														onFocus={this.props.onFocusPhone}
														datatest="main_callback_input_tel"
													/>
												</AlertWrapper>
											</div>
											<Button
												fullWidth={true}
												status={"tertiaryAccent"}
												datatest="provides_form_findtariff_input_waitcall_button"
												onClick={(e) => this.props.sendOrder(e, this.carousel)}
											>
												{text.CALLBACK_FORM_BUTTON}
											</Button>
										</div>
									</form>
								)}
								{callbackSended && (
									<div className={classNames(classes.windowWrapper, classes.windowWrapperSuccess)}>
										<FromFade>
											<Welcome
												dark={true}
												title={text.WELCOME_CB_WIDGET_TITLE}
												text={text.WELCOME_CB_WIDGET_TEXT}
											/>
										</FromFade>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(CallbackFixed);
